import React from 'react';
import {
  BASIS,
  OPERATORS,
  basisOf,
  basisTitle,
  exampleAmounts,
  exampleJournal,
  percentEntry,
  rateEntry,
} from './accountantModel';
import CalculationAgent from './CalculationAgent';

export default function AccountantBuilder(props) {
  return <CalculationAgent {...props} />;
}

function termLabel(term, parameters, namedValues) {
  if (term.kind === 'input') {
    if (term.key === 'cost_this_period') return 'Project costs this period';
    if (term.key === 'gross_owner_billing_period') return 'Owner billing this period';
    if (term.key === 'revenue_this_period') return 'Revenue this period';
    if (term.key === 'current_contract_value') return 'Current contract value';
    if (term.key === 'total_commitment_amount') return 'Total commitment amount';
    if (term.key === 'manual_amount') return 'Amount entered this period';
    return basisTitle(term.key) || 'Choose a value';
  }
  if (term.kind === 'parameter') {
    const row = parameters.find((item) => item.key === term.key);
    if (!row) return 'Rate';
    if (row.display === 'percent' && rateEntry(row)) return `${row.label} ${rateEntry(row)}%`;
    if (row.display === 'per_thousand' && row.defaultValue) return `${row.label} $${row.defaultValue} per $1,000`;
    return row.label;
  }
  if (term.kind === 'named') return namedValues.find((row) => row.key === term.key)?.label || 'Calculated amount';
  if (term.kind === 'constant') return term.value || 'Number';
  return 'Choose a value';
}

export function PublishSummary({ summary }) {
  if (!summary) return null;
  return (
    <div className="text-sm text-gray-800">
      <div className="font-semibold text-gray-900 mb-1">{summary.name || 'Calculation'}</div>
      <div className="mb-2">{summary.basis}</div>
      {summary.equations.map((row) => <div key={row.label}>{row.label}: {row.text}</div>)}
      {summary.rates.map((row) => <div key={row.label}>Default {row.label}: {row.value}</div>)}
      <div className="mt-2">
        {summary.journal.map((row, index) => (
          <div key={`${row.side}-${index}`}>{row.side} {row.account} — {row.amountLabel}</div>
        ))}
      </div>
    </div>
  );
}

export function publishedSummary({ name, parameters, namedValues, accountingLines }) {
  const basis = basisOf(namedValues);
  const examples = exampleAmounts(parameters, namedValues);
  return {
    name,
    basis: basis === 'mixed' ? 'More than one basis' : (BASIS.find((item) => item.key === basis)?.help || 'Not chosen'),
    equations: namedValues.filter((row) => row.label).map((row) => ({
      label: row.label,
      text: row.terms.map((term, index) => (
        `${index ? `${OPERATORS.find((op) => op.value === row.operators[index - 1])?.label || ''} ` : ''}${termLabel(term, parameters, namedValues)}`
      )).join(' '),
    })),
    rates: parameters.filter((row) => row.key).map((row) => ({
      label: row.label,
      value: row.display === 'percent' ? `${percentEntry(row.defaultValue)}%` : row.display === 'per_thousand' ? `$${row.defaultValue} per $1,000` : String(row.defaultValue || ''),
    })),
    journal: exampleJournal(accountingLines, namedValues, examples).rows,
  };
}
